<template>
  <div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">标签</li>
    </ol>
    <div class="am-form">
      <div class="am-form-group">
        <span class="am-margin-right" v-for="tag in tagList">
          <router-link :key="tag.id" :to="{path:`/edit/tag/${tag.slug}`}">{{tag.title}}</router-link>
        </span>
      </div>
      <div class="am-form-group">
        <label for="title">标签名</label>
        <input id="title" type="text" class="am-form-field am-radius" placeholder="请输入标签名..." v-model="title"/>
      </div>
      <div class="am-form-group">
        <label for="slug">标签缩略名</label>
        <input id="slug" type="text" class="am-form-field am-radius" placeholder="请输入标签缩略名..." v-model="slug"/>
      </div>
      <div class="am-form-group am-margin-top">
        <button class="am-btn am-btn-primary am-btn-xs" @click="save">保存</button>
      </div>
    </div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">标签</li>
    </ol>
  </div>
</template>

<script>
import { adminTagGetList, adminTagGet, adminTagSave } from '@/request'
import {Toast} from "mint-ui"
export default {
  name: 'EditTag',
  data () {
    return {
      id: null,
      slug: null,
      title: '',
      tagList: []
    }
  },
  mounted () {
    this.resetData()
  },
  watch: {
    $route: {
      handler: 'resetData'
    },
    title (val) {
      document.title = `${val}｜编辑`
    }
  },
  methods: {
    resetData () {
      const slug = this.$route.params.slug
      if(slug) {
        adminTagGet({ slug }).then(res => {
          this.id = res.id
          this.slug = res.slug
          this.title = res.title
        })
      }
      adminTagGetList().then(res => {
        this.tagList = res
      })
    },
    save () {
      adminTagSave({
        id: this.id,
        slug: this.slug,
        title: this.title,
        content: this.content,
        allowComment: this.allowComment,
        status: this.status,
        password: this.password
      }).then(res => {
        this.id = res
        Toast("保存成功")
        this.$router.push({path:`/edit/tag/${this.slug}`})
        this.resetData()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditTag.vue